<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h1>Order {{ currentOrderId }}</h1>
        <p>Kund: {{ currentOrderCustomer }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Order',
  data () {
    return {
      id: 0,
      currentIndex: 0,
      currentOrderId: '',
      currentOrderCustomer: '',
      items: [
        {
          orderId: '1',
          orderNr: '12345',
          customer: 'Feralco',
          productName: 'Produktnamn',
          status: 'Pågående'
        },
        {
          orderId: '2',
          orderNr: '67891',
          customer: 'Hydro Building',
          productName: 'Produktnamn 2',
          status: 'Klar för fakturering'
        },
        {
          orderId: '3',
          orderNr: '678922',
          customer: 'Hydro Building',
          productName: 'Produktnamn 2',
          status: 'Klar för fakturering'
        }
      ]
    }
  },
  created () {
    this.id = this.$route.params.id
    this.selectItem(
      this.items, item => item.orderId === this.id
    )
  },
  methods: {
    selectItem (array, conditionFn) {
      const item = array.find(conditionFn)
      this.currentOrderId = item.orderId
      this.currentOrderCustomer = item.customer
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Order.vue